export default function calculator(element) {
    let rawData = element.dataset.ftu_values;
    if (!rawData) return;

    let ftuData;
    try {
        ftuData = JSON.parse(rawData);
    } catch (e) {
        console.error('JSON error:', e);
        return;
    }

    let ageSelect = element.querySelector('select[name="age_id"]');
    let placeSelect = element.querySelector('select[name="place_id"]');
    let button = element.querySelector('.js-calc');
    let resBlock = element.querySelector('.js-result__calc');
    let resBlockValue = element.querySelector('.js-result_calc_value');

    if (!ageSelect || !placeSelect || !button || !resBlock || !resBlockValue) return;

    let wasCalculated = false;

    function updateButtonState() {
        let ageId = ageSelect.value;
        let placeId = placeSelect.value;
        let ready = ageId && placeId;

        button.disabled = !ready;

        if (ready) {
            updateResult();
        } else if (!wasCalculated) {
            resBlock.classList.add('hide');
            button.style.display = ''; 
        }
    }

    function updateResult() {
        let ageId = ageSelect.value;
        let placeId = placeSelect.value;
        let key = `${ageId}_${placeId}`;
        let result = ftuData[key];

        if (result) {
            resBlockValue.textContent = result;
        }

        resBlock.classList.remove('hide');
        button.style.display = 'none';
        // wasCalculated = true;
    }

    function handleClick(e) {
        e.preventDefault();
        updateResult();
    }

    ageSelect.addEventListener('change', updateButtonState);
    placeSelect.addEventListener('change', updateButtonState);
    button.addEventListener('click', handleClick);

    updateButtonState();
}